import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { FieldInstance } from "../core/components/field";
import { CreateMultipleAssignmentsContext, CustomRepetitionInfo, Position, Repetition, RepetitionInfo, StandardRepetitionInfo } from "./createMultipleAssignments";
import { DropDownList } from "../core/components/dropDownList";
import { DatePicker } from "../core/components/datePicker";
import { DateTimePicker } from "../core/components/dateTimePicker";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { SimpleRadioButton } from "../core/components/simpleRadioButton";
import { TimePicker } from "../core/components/timePicker";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import { SimpleCheckBoxProps } from "../core/components/simpleCheckBox";
import { KeyValuePair, StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class RepetitionInfoApp extends React.Component<RepetitionInfoProps, RepetitionInfo>{
    private factory = ComponentHelper.createFactory();

    constructor(props: RepetitionInfoProps) {
        super(props)
        const start = props.context.start;
        const end = props.context.end;
        const dayOfWeek = start.getDay() as DayOfWeek;
        this.state = {
            Repetition: Repetition.None,
            RepetitionUntil: null,
            StandardRepetitionInfo: {
                AssignmentStart: start,
                AssignmentEnd: end, //Helper.dates.addHours(start, props.context.duration)
            },
            CustomRepetitionInfo: {
                Repetition: Repetition.Daily,
                AssignmentDuration: 60 * props.context.duration,
                RepeatAll: 1,
                Start: new Date(start.getFullYear(), start.getMonth(), start.getDate()),
                StartTime: start.getHours() * 60 + start.getMinutes(),
                DaysOfWeek: [dayOfWeek],
                DayOfWeek: dayOfWeek,
                Position: Position.First,
                SpecificDay: start.getDate()
            }
        }
    }

    private afterValueChange = () => {
        this.props.onChange(this.props.field, this.state);
    }

    private renderRepetitionSelection = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.props.dataSource;
        props.value = this.state.Repetition;
        props.field.optionLabel = "";
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.onChange = (_, value: Repetition) => {
            this.setState({ Repetition: value }, this.afterValueChange)
        }
        return (
            <>
                <FieldInstance label={this.props.context.translations["Einsatz.MultipleCreation.Repetition"]}>
                    <DropDownList {...props} />
                </FieldInstance>
            </>
        );
    }

    private renderWeekendSchemaSelection = () => {
        if (this.state.Repetition != Repetition.Workday || this.props.context.weekendSchemas.length === 1) {
            return null;
        }


        const props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.props.context.weekendSchemas;
        props.value = this.state.WeekendSchemaId;
        props.field.optionLabel = "";
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.onChange = (_, value: number) => {
            this.setState({ WeekendSchemaId: value }, this.afterValueChange)
        }
        return (
            <>
                <FieldInstance label={Helper.getTranslation("Field.Ressource.wochenendid")}>
                    <DropDownList {...props} />
                </FieldInstance>
            </>
        );
    }

    private renderUntilDatePicker = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.value = this.state.RepetitionUntil;
        props.onChange = (_, value: Date | string) => {
            if (this.state.Repetition == Repetition.Custom) {
                if (Helper.dates.toDate(value) < Helper.dates.toDate(this.state.CustomRepetitionInfo.Start)) {
                    value = this.state.RepetitionUntil;
                }
            } else {
                if (Helper.dates.toDate(value) < Helper.dates.toDate(this.state.StandardRepetitionInfo.AssignmentEnd)) {
                    value = this.state.RepetitionUntil;
                }
            }
            this.setState({ RepetitionUntil: Helper.dates.toDate(value) }, this.afterValueChange)
        }
        //props.field.min = this.state.Repetition == Repetition.Custom ? this.state.CustomRepetitionInfo.Start : this.state.StandardRepetitionInfo.AssignmentEnd;

        const name = Helper.getTranslation("Einsatz.MultipleCreation.EndsOn");

        props.required = this.state.Repetition != Repetition.None;
        props.field.required = this.state.Repetition != Repetition.None;
        props.field.name = name;
        props.field.model = "entity.RepetitionInfo.RepetitionUntil";
        return (
            <div style={{ display: this.state.Repetition == Repetition.None ? "none" : "block" }}>
                <FieldInstance label={name + "*"}>
                    <DatePicker {...props} />
                </FieldInstance>
            </div>
        );
    }

    private renderStandardRepetitionInfoApp = () => {
        const props: ExtendedRepetitionInfoProps<StandardRepetitionInfo> = {
            translations: this.props.context.translations,
            onChange: (info) => {
                this.setState({ StandardRepetitionInfo: info }, this.afterValueChange)
            },
            infos: this.state.StandardRepetitionInfo,
            handleEval: this.props.handleEval,
            until: this.state.RepetitionUntil
        }

        return (
            <div style={{ display: this.state.Repetition != Repetition.Custom ? "block" : "none" }}>
                <StandardRepetitionInfoApp {...props} />
            </div>
        );
    }

    private renderCustomRepetitionInfoApp = () => {
        const props: ExtendedRepetitionInfoProps<CustomRepetitionInfo> = {
            translations: this.props.context.translations,
            onChange: (info) => {
                this.setState({ CustomRepetitionInfo: info }, this.afterValueChange)
            },
            infos: this.state.CustomRepetitionInfo,
            handleEval: this.props.handleEval,
            until: this.state.RepetitionUntil
        }

        return (
            <div style={{ display: this.state.Repetition == Repetition.Custom ? "block" : "none" }}>
                <CustomRepetitionInfoApp {...props} />
            </div>
        );
    }

    componentDidMount() {
        this.afterValueChange();
    }

    render() {
        return (
            <>
                {this.renderRepetitionSelection()}
                {this.renderWeekendSchemaSelection()}
                {this.renderUntilDatePicker()}
                {this.renderStandardRepetitionInfoApp()}
                {this.renderCustomRepetitionInfoApp()}                
            </>
        );
    }
}

interface RepetitionInfoProps extends BaseComponentProps {
    context: CreateMultipleAssignmentsContext;
    dataSource: KeyValuePair<Repetition, string>[];
    handleEval: (action, prepare) => any;
}

interface ExtendedRepetitionInfoProps<T> {
    translations: StringKeyDictionary<string>;
    infos: T;
    onChange: (infos: T) => void
    handleEval: (action, prepare) => any;
    until: Date;
}

class StandardRepetitionInfoApp extends React.Component<ExtendedRepetitionInfoProps<StandardRepetitionInfo>, StandardRepetitionInfo>{

    private factory = ComponentHelper.createFactory();

    constructor(props: ExtendedRepetitionInfoProps<StandardRepetitionInfo>) {
        super(props)
        this.state = props.infos
    }


    private afterValueChange = () => {
        this.props.onChange(this.state);
    }

    private renderStartDateTimePicker = () => {
        const props = this.factory.getDefaultDateTimePickerProps();
        props.handleEval = this.props.handleEval;
        props.value = this.state.AssignmentStart;
        props.onChange = (_, value: Date | string) => {
            if (!Helper.hasValue(value))
                value = this.state.AssignmentStart
            this.setStart(Helper.dates.toDate(value));
        }
        return (
            <>
                <FieldInstance label={this.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.MinStart"]}>
                    <DateTimePicker {...props} />
                </FieldInstance>
            </>
        );
    }

    private setStart = (value: Date) => {
        if (value > this.state.AssignmentEnd) {
            const diff = (this.state.AssignmentEnd.getTime() - this.state.AssignmentStart.getTime()) / 1000
            const end = Helper.dates.addSeconds(value, diff);
            this.setState({ AssignmentEnd: end });
        }
        this.setState({ AssignmentStart: value }, this.afterValueChange)
    }

    private renderEndDateTimePicker = () => {
        const props = this.factory.getDefaultDateTimePickerProps();
        props.handleEval = this.props.handleEval;
        props.value = this.state.AssignmentEnd;
        props.onChange = (_, value: Date | string) => {
            if (!Helper.hasValue(value))
                value = this.state.AssignmentEnd
            this.setEnd(Helper.dates.toDate(value));
        }

        return (
            <>
                <FieldInstance label={this.props.translations["Field.Einsatz.endeist"]}>
                    <DateTimePicker {...props} />
                </FieldInstance>
            </>
        );
    }

    private setEnd = (value: Date) => {
        if (value <= this.state.AssignmentStart) {
            const diff = (this.state.AssignmentEnd.getTime() - this.state.AssignmentStart.getTime()) / 1000
            const start = Helper.dates.addSeconds(value, -1 * diff);
            this.setState({ AssignmentStart: start })
        }
        this.setState({ AssignmentEnd: value }, this.afterValueChange)
    }

    render() {
        return (
            <>
                {this.renderStartDateTimePicker()}
                {this.renderEndDateTimePicker()}
            </>
        );
    }
}

class CustomRepetitionInfoApp extends React.Component<ExtendedRepetitionInfoProps<CustomRepetitionInfo>, CustomRepetitionInfo>{

    private factory = ComponentHelper.createFactory();

    constructor(props: ExtendedRepetitionInfoProps<CustomRepetitionInfo>) {
        super(props)
        this.state = props.infos
    }

    private afterValueChange = () => {
        this.props.onChange(this.state);
    }

    private renderStartTimePicker = () => {
        const props = this.factory.getDefaultTimePickerProps();
        props.value = Helper.dates.addMinutes(this.state.Start, this.state.StartTime);
        props.onChange = (_, value: Date) => {
            value = Helper.dates.toDate(value)
            const time = (value.getHours() * 60) + value.getMinutes();
            this.setState({ StartTime: time }, this.afterValueChange)
        }
        return (
            <>
                <FieldInstance label={this.props.translations["Einsatz.MultipleCreation.StartTime"]}>
                    <TimePicker {...props} />
                </FieldInstance>
            </>
        );
    }

    private renderStartDatePicker = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.value = this.state.Start;
        props.onChange = (_, value: Date | string) => {
            this.setStart(Helper.dates.toDate(value));
        }
        //props.field.max = this.props.until;
        return (
            <>
                <FieldInstance label={this.props.translations["Einsatz.MultipleCreation.StartOn"]}>
                    <DatePicker {...props} />
                </FieldInstance>
            </>
        );
    }

    private setStart = (value: Date) => {
        if (Helper.dates.toDate(value) > Helper.dates.toDate(this.props.until)) {
            value = this.state.Start;
        }
        this.setState({ Start: value }, this.afterValueChange)
    }

    private renderDuration = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.AssignmentDuration / 60;
        props.field.min = 0.5;
        props.field.format = "#.00h";
        props.field.decimals = 2;
        props.onChange = (_, value: number) => {
            this.setState({ AssignmentDuration: value * 60 }, this.afterValueChange)
        }
        return (
            <>
                <FieldInstance label={this.props.translations["Einsatz.MultipleCreation.Duration"]}>
                    <IsNumericTextBox {...props} />
                </FieldInstance>
            </>
        );
    }

    private renderRepeatSelection = () => {
        const dropDownProps = this.factory.getDefaultDropDownProps();
        dropDownProps.dataSource = [
            { Key: Repetition.Daily, Value: this.props.translations["Field.Enum.PeriodUnits.Days"] },
            { Key: Repetition.Weekly, Value: this.props.translations["Field.Enum.PeriodUnits.Weeks"] },
            { Key: Repetition.Monthly, Value: this.props.translations["Field.Enum.PeriodUnits.Months"] },
        ];
        dropDownProps.value = this.state.Repetition;
        dropDownProps.field.optionLabel = "";
        dropDownProps.field.dataTextField = "Value";
        dropDownProps.field.dataValueField = "Key";
        dropDownProps.onChange = (_, value: Repetition) => {
            this.setState({ Repetition: value }, this.afterValueChange)
        }

        const numericProps = this.factory.getDefaultNumericTextBoxProps();
        numericProps.value = this.state.RepeatAll;
        numericProps.field.min = 1;
        numericProps.onChange = (_, value) => {
            this.setState({ RepeatAll: value }, this.afterValueChange)
        }

        return (
            <>
                <FieldInstance label={this.props.translations["Einsatz.MultipleCreation.RepeatAll"]}>
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "30%", marginRight: "10px" }}>
                            <IsNumericTextBox {...numericProps} />
                        </div>
                        <div style={{ flex: "1" }}>
                            <DropDownList {...dropDownProps} />
                        </div>
                    </div>
                </FieldInstance>
            </>
        );
    }

    private renderDayOfWeekSelection = () => {
        const props: DayOfWeekSelectionProps = {
            value: this.state.DaysOfWeek,
            onChange: (value) => {
                if (value.length == 0)
                    value = this.state.DaysOfWeek
                this.setState({ DaysOfWeek: value }, this.afterValueChange)
            }
        }
        return (
            <div style={{ display: this.state.Repetition == Repetition.Weekly ? "block" : "none" }}>
                <FieldInstance>
                    <DayOfWeekSelection {...props} />
                </FieldInstance>
            </div>
        );
    }

    private renderMonthlySelection = () => {
        const props: MonthlySelectionProps = {
            startsOn: this.props.infos.Start,
            dayOfWeek: this.state.DayOfWeek,
            position: this.state.Position,
            specificDay: this.state.SpecificDay,
            onChange: this.onMonthlySelectionChange,
            translations: this.props.translations
        }
        return (
            <div style={{ display: this.state.Repetition == Repetition.Monthly ? "block" : "none" }}>
                <FieldInstance>
                    <MonthlySelection {...props} />
                </FieldInstance>
            </div>
        );
    }

    private onMonthlySelectionChange = (specificDay: number, dayOfWeek: DayOfWeek, position: Position) => {
        this.setState({ SpecificDay: specificDay, DayOfWeek: dayOfWeek, Position: position }, this.afterValueChange)
    }

    render() {
        return (
            <>
                {this.renderStartDatePicker()}
                {this.renderStartTimePicker()}
                {this.renderDuration()}
                {this.renderRepeatSelection()}
                {this.renderDayOfWeekSelection()}
                {this.renderMonthlySelection()}
            </>
        );
    }
}

class DayOfWeekSelection extends React.Component<DayOfWeekSelectionProps, any>{

    private dataSource: KeyValuePair<DayOfWeek, string>[] = [
        { Key: DayOfWeek.Monday, Value: "Mo" },
        { Key: DayOfWeek.Tuesday, Value: "Di" },
        { Key: DayOfWeek.Wednesday, Value: "Mi" },
        { Key: DayOfWeek.Thursday, Value: "Do" },
        { Key: DayOfWeek.Friday, Value: "Fr" },
        { Key: DayOfWeek.Saturday, Value: "Sa" },
        { Key: DayOfWeek.Sunday, Value: "So" }
    ]

    constructor(props) {
        super(props)
        this.initApp();
    }

    private initApp = async () => {
        const translations = await (await Helper.getTranslations(["Einsatz.MultipleCreation.WeekDayShort.Di", "Einsatz.MultipleCreation.WeekDayShort.Do",
            "Einsatz.MultipleCreation.WeekDayShort.Fr", "Einsatz.MultipleCreation.WeekDayShort.Mi", "Einsatz.MultipleCreation.WeekDayShort.Mon",
            "Einsatz.MultipleCreation.WeekDayShort.Sa", "Einsatz.MultipleCreation.WeekDayShort.So"
        ])).Data;
        this.dataSource = [
            { Key: DayOfWeek.Monday, Value: translations["Einsatz.MultipleCreation.WeekDayShort.Mon"] },
            { Key: DayOfWeek.Tuesday, Value: translations["Einsatz.MultipleCreation.WeekDayShort.Di"] },
            { Key: DayOfWeek.Wednesday, Value: translations["Einsatz.MultipleCreation.WeekDayShort.Mi"] },
            { Key: DayOfWeek.Thursday, Value: translations["Einsatz.MultipleCreation.WeekDayShort.Do"] },
            { Key: DayOfWeek.Friday, Value: translations["Einsatz.MultipleCreation.WeekDayShort.Fr"] },
            { Key: DayOfWeek.Saturday, Value: translations["Einsatz.MultipleCreation.WeekDayShort.Sa"] },
            { Key: DayOfWeek.Sunday, Value: translations["Einsatz.MultipleCreation.WeekDayShort.So"] }
        ];
        this.setState({});
    }

    private onButtonClick = (value: DayOfWeek) => {
        let data = this.props.value;
        if (data.findIndex(f => f == value) === -1) {
            data.push(value); //add
        } else {
            data = data.filter(f => f !== value); //remove 
        }
        this.props.onChange(data)
    }

    private createButton = (item: KeyValuePair<DayOfWeek, string>) => {
        const isActive = this.props.value.findIndex(f => f == item.Key) > -1;
        let className = "dayOfWeekSelection__item ";
        if (isActive) {
            className += "dayOfWeekSelection__item--activ"
        } else {
            className += "dayOfWeekSelection__item--inactiv"
        }
        return (
            <React.Fragment key={kendo.guid()}>
                <div onClick={() => { this.onButtonClick(item.Key) }} className={className}>
                    <label>
                        {item.Value}
                    </label>
                </div>
            </React.Fragment>
        );
    }

    private renderButtons = () => {
        return (
            <div className="dayOfWeekSelection">
                {this.dataSource.map(this.createButton)}
            </div>
        );
    }

    render() {
        return this.renderButtons();
    }
}

interface DayOfWeekSelectionProps {
    value: DayOfWeek[];
    onChange: (value: DayOfWeek[]) => void;
}

//Wie in C#
export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

class MonthlySelection extends React.Component<MonthlySelectionProps, MonthlySelectionState>{

    private factory = ComponentHelper.createFactory();
    private positionDataSource: KeyValuePair<Position, string>[];
    private dayOfWeekDataSource: KeyValuePair<DayOfWeek, string>[];


    constructor(props: MonthlySelectionProps) {
        super(props)

        this.state = {
            mode: 1,
            dayOfWeek: props.dayOfWeek,
            position: props.position,
            specificDay: props.specificDay
        }
        this.initApp();
    }

    private initApp = () => {
        this.positionDataSource = [];
        const p = Position as any;
        for (let k in p) {
            if (Helper.isNumber(k)) {
                this.positionDataSource.push({
                    Key: parseInt(k) as Position,
                    Value: this.props.translations[`Einsatz.MultipleCreation.Position.${p[k]}`]
                })
            }
        }
        this.dayOfWeekDataSource = [];
        const dw = DayOfWeek as any;
        for (let k in dw) {
            if (Helper.isNumber(k)) {
                this.dayOfWeekDataSource.push({
                    Key: parseInt(k) as DayOfWeek,
                    Value: this.props.translations[`Einsatz.MultipleCreation.DayOfWeek.${dw[k]}`]
                })
            }
        }
    }

    private afterValueChanged = () => {
        switch (this.state.mode) {
            case 1:
                this.props.onChange(this.state.specificDay, null, null);
                break;
            case 2:
                this.props.onChange(null, this.state.dayOfWeek, this.state.position);
                break;
        }
    }

    private renderMode1Selection = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.specificDay;
        props.field.min = 1;

        props.field.max = this.calculateMaxValue();

        props.disabled = this.state.mode == 2;
        props.onChange = (_, value: number) => {
            if (!Helper.hasValue(value))
                value = this.state.specificDay;
            this.setState({ specificDay: value }, this.afterValueChanged)
        }
        return (
            <>
                <RadioComponentContainer value={this.state.mode == 1} onChange={this.onMode1Change}>
                    <label style={{ paddingRight: "10px", color: this.state.mode == 1 ? "#000000" : "#333333" }}>
                        {this.props.translations["Einsatz.MultipleCreation.OnDay"]}
                    </label>
                    <div style={{ width: "75px" }}>
                        <IsNumericTextBox {...props} />
                    </div>
                </RadioComponentContainer>
            </>
        );
    }

    private calculateMaxValue = () => {
        const start = Helper.dates.toDate(this.props.startsOn);
        let tmp = new Date(start.getFullYear(), start.getMonth(), 1)
        tmp = Helper.dates.addMonths(tmp, 1);
        tmp = Helper.dates.addDays(tmp, -1);
        return tmp.getDate();
    }

    private onMode1Change = (value: boolean) => {
        if (value) {
            this.setState({ mode: 1 }, this.afterValueChanged)
        }
    }

    private renderMode2Selection = () => {
        const posProps = this.factory.getDefaultDropDownProps();
        posProps.dataSource = this.positionDataSource;
        posProps.value = this.state.position;
        posProps.field.optionLabel = "";
        posProps.field.dataTextField = "Value";
        posProps.field.dataValueField = "Key";
        posProps.disabled = this.state.mode == 1
        posProps.onChange = (_, value: Position) => {
            this.setState({ position: value }, this.afterValueChanged)
        }

        const dayProps = this.factory.getDefaultDropDownProps();
        dayProps.dataSource = this.dayOfWeekDataSource;
        dayProps.value = this.state.dayOfWeek;
        dayProps.field.optionLabel = "";
        dayProps.field.dataTextField = "Value";
        dayProps.field.dataValueField = "Key";
        dayProps.disabled = this.state.mode == 1
        dayProps.onChange = (_, value: DayOfWeek) => {
            this.setState({ dayOfWeek: value }, this.afterValueChanged)
        }

        return (
            <>
                <RadioComponentContainer value={this.state.mode == 2} onChange={this.onMode2Change}>
                    <label style={{ color: this.state.mode == 2 ? "#000000" : "#333333" }}>
                        {this.props.translations["Einsatz.MultipleCreation.At"]}
                    </label>
                    <div style={{ margin: "0 10px" }}>
                        <DropDownList {...posProps} />
                    </div>
                    <DropDownList {...dayProps} />
                </RadioComponentContainer>
            </>
        );
    }


    private onMode2Change = (value: boolean) => {
        if (value) {
            this.setState({ mode: 2 }, this.afterValueChanged)
        }
    }

    render() {
        return (
            <>
                {this.renderMode1Selection()}
                {this.renderMode2Selection()}
            </>
        );
    }
}

interface MonthlySelectionProps {
    startsOn: Date | string;
    specificDay: number;
    dayOfWeek: DayOfWeek;
    position: Position;
    onChange: (specificDay: number, dayOfWeek: DayOfWeek, position: Position) => void;
    translations: StringKeyDictionary<string>;
}

interface MonthlySelectionState {
    mode: 1 | 2;
    specificDay: number;
    dayOfWeek: DayOfWeek;
    position: Position;
}

class RadioComponentContainer extends React.Component<RadioComponentContainerProps, any>{
    private radioButtonProps: SimpleCheckBoxProps;

    constructor(props: RadioComponentContainerProps) {
        super(props)
        this.initApp();
    }

    private initApp = () => {
        this.radioButtonProps = {
            label: "",
            onChange: this.props.onChange,
            value: this.props.value,
            disabled: false,
            inputStyle: {
                alignSelf: "center"
            }
        }
    }

    private onClick = () => {
        if (!this.props.value)
            this.props.onChange(true);
    }

    render() {
        this.radioButtonProps.value = this.props.value;

        return (
            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px", width: "fit-content" }} onClick={this.onClick}>
                <div style={{ marginRight: "10px", display: "flex" }}>
                    <SimpleRadioButton {...this.radioButtonProps} />
                </div>
                {this.props.children}
            </div>
        );
    }
}

interface RadioComponentContainerProps extends React.PropsWithChildren {
    onChange: (isActive: boolean) => void;
    value: boolean;
}